export default import.meta.ROLLDOWN_FILE_URL_O_tdf$QPvJNjf2YYamgnkg